import { getFromQuery } from "./getFromQuery";

export function getFormSessionStorageOrQuery(
  key: string,
  query: Record<string, string | string[] | undefined>,
) {
  const fromStorage = sessionStorage.getItem(key);
  if (fromStorage) {
    sessionStorage.removeItem(key);
    return fromStorage;
  }
  return getFromQuery(key, query);
}
